
<template>
    <div title="Property Information">
        <div class="row">
            <div class="col">
                <h4>{{ question }}</h4>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="contain">
                <div v-if="!showForm">
                    <b-form-group
                        id="fieldset-1"
                        description=""
                        label=""
                        label-for="address">
                        <map-box-textbox 
                            ref="mb"
                            :value="address"
                            :search-type="type === 'buy' ? 'place' : 'address'"
                            @on-location-selection="locationSelected"
                            @enter-manually="toggleForm"
                            @on-error="onError"
                            @on-blur="onBlur" />
                    </b-form-group>
                    <div>
                        <small
                            v-if="type === 'buy'"
                            style="position:relative;top:-1em;"
                        >
                            Please enter a city and state
                        </small>
                    </div>
                </div>
                <address-form 
                    v-else
                    @on-success="onFormSuccess"
                    @on-invalid="onFormInvalid"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {saveField} from '@/services/apiService';
import {Sources} from '@/config/constants';
import MapBoxTextbox from './input/MapBoxTextbox.vue';
import AddressForm from './AddressForm.vue';
import { setLocationPreferenceBoundingBox, 
    getMapBoxSelections, getLocationResults,
    isValidLatLngFromUrlObject, isValidFromUrlObject } from '@/utils';

export default {
    name: "Address",
    props: ['value', 'source', 'type', 'urlAddress'],
    components: {
        AddressForm,
        MapBoxTextbox
    },
    data() {
        return {
            address: '',
            location: {},
            question: 'Enter the address of the property you wish to sell',
            showForm: false,
        }
    },
    async mounted() {
        if (this.type === 'buy') this.question = 'Where would you like to purchase?'

        const isValidLatLng = isValidLatLngFromUrlObject(this.urlAddress);
        const isBaseUrl = isValidFromUrlObject(this.urlAddress, ['address', 'latitude', 'longitude', 'city', 'state']);
        const isSellerUrl = isValidFromUrlObject(this.urlAddress, ['zip', 'street']);

        if (this.type === 'sell' && isValidLatLng && isBaseUrl && isSellerUrl) {
            this.$emit('input', this.address);
            this.$emit('location', this.urlAddress);
        } else if (this.type === 'buy' && isValidLatLng && isBaseUrl) {
            this.$emit('input', this.address);
            this.$emit('location', this.urlAddress);
        } else if (this.address && !isValidLatLng) {
            const mapBoxType = this.type === 'buy' ? 'place' : 'address'
            const result = await getLocationResults(this.address, mapBoxType);
            if (result.length > 0 && result[0].place_name === this.address) {
                const parsedInfo = getMapBoxSelections(result[0]);
                this.$emit('input', this.address);
                this.$emit('location', parsedInfo);
            }
        }
    },
    methods: {
        locationSelected: function(item) {
            if (this.source === Sources.RDR && !this.location.lat) {
                return;
            }
            if (typeof item.place_name !== 'undefined') {
                const mapBoxInfo = getMapBoxSelections(item);
                mapBoxInfo.type = this.type ?? 'sell';
                this.saveField(item.place_name);
                setLocationPreferenceBoundingBox(mapBoxInfo.type, item);
                this.$emit('input', item.place_name);
                this.$emit('location', mapBoxInfo);
            } else {
                this.checkTextValue();  
            }
        },
        checkTextValue: function() {
            const tbxValue = this.$refs.mb.$refs.tbxMapBox.value;
            if (tbxValue == '') this.$emit('input', '');
        },
        saveField: function(value) {
            const fieldName = this.type === 'buy' ? 'Place' : 'Street'
            saveField(fieldName, value);
        },
        onError: function(text) {
            this.$emit('input', text);
        },
        onBlur: function() {
            this.checkTextValue(); 
        },
        onFormSuccess: async function(form) {
            let result = { ...form }
            const results = await getLocationResults(form.address, 'address');
  
            if (results.length > 0) {
                result['latitude'] = results[0].geometry.coordinates[1];
                result['longitude'] = results[0].geometry.coordinates[0];
            }

            this.$emit('formLocation', result);
            this.$emit('input', result.address);
        },
        onFormInvalid: function() {
            this.$emit('input', '');
        },
        toggleForm: function() {
            if (!this.showForm) this.$emit('input', '');
            this.showForm = !this.showForm
        }
    }
}
</script>

<style scoped>
</style>

